<div class="additional-products-selection">
  <div class="current-product">
    <div class="product">
      <h4 class="product-name">
        {{ productConfig.name }}
      </h4>
    </div>

    <span class="product-price">
      <price-display [price]="priceCalculationService.singleProductTotal"
        [quantity]="productConfig.quantity">
      </price-display>
    </span>
  </div>
  <hr />

  <div class="additional-products-title">
    {{ 'i18n.additionalProducts.title' | translate }}
  </div>

  <div class="additional-products">
    <div [ngClass]="productConfig.additionalProducts.length === 1 ?
                    'one-column' : 'two-columns'">
      @if (productConfig.additionalProducts[0]; as product) {
        <div class="main-additional-product additional-product"
             [ngStyle]="productConfig.additionalProducts.length > 3 ?
                        {'justify-content': 'initial'} : null"
          >
          <div class="product-image">
            @if (getFeatureGroupsCount(product) !== 1) {
              @if (product.image) {
                <img src="{{product.image.mediumURL}}"
                     alt="{{product.image.altText}}" />
              }
            }
            @if (getFeatureGroupsCount(product) === 1) {
              @if (getSelectedFeature(product) &&
                getSelectedFeatureMediaUrl(product)) {
                <img
                  src="{{ getSelectedFeatureMediaUrl(product) }}" alt=""/>
              }
            }
          </div>
          <div class="product-title">
            {{ 'i18n.additionalProducts.emotionalHook' | translate }}
            {{ product.name }}
          </div>
        <price-display [price]="priceCalculationService
                                  .getProductPriceWithFeatures(product)"
            [quantity]="product.quantity">
          </price-display>
          <input class="acc-checkbox" type="checkbox" id="acc-main" />
          <label for="acc-main" class="acc-label">
            {{ 'i18n.additionalProducts.showMore' | translate }}
          </label>
          <ul class="details">
            @for (detail of product.bulletedDescription; track detail) {
              <li
                [innerHTML]="detail">
              </li>
            }
          </ul>
          @if (getFeatureGroupsCount(product) > 0) {
            <div class="feature-selection"
              >
              @for (group of objToArray(product.featureGroups); track trackById($index, group)) {
                <div class="feature-group"
                  >
                  <span class="group-name">
                    {{ group.name }}:
                  </span>
                  <single-option-chooser [displayStyle]="'DropDown'"
                    [options]="getFeaturesAsOptions(group)"
                    [selectedValue]="group.selectedFeature"
                                   (selectedValueChange)="selectedValueChanged(
                                       product.id, group.id, $event)">
                  </single-option-chooser>
                </div>
              }
            </div>
          }
          <div class="add-to-cart-container">
            <mat-checkbox [checked]="additionalProductIsSelected(product.id)"
              [labelPosition]="'before'"
                        (change)="setAdditionalProductIsSelected(
                                      product.id, $event.source.checked)">
              <a mat-raised-button size="small" color="primary">
                {{ 'i18n.additionalProducts.addToCart' | translate }}
              </a>
            </mat-checkbox>
          </div>
        </div>
      }

      @if (productConfig.additionalProducts.length > 1) {
        <div class="other-additional-products"
          >
          @for (product of productConfig.additionalProducts; track trackById(i, product); let i = $index) {
            @if (i > 0) {
              <div class="other-additional-product additional-product"
                >
                <div class="product-info">
                  <div class="product-image">
                    @if (getFeatureGroupsCount(product) !== 1) {
                      @if (product.image) {
                        <img src="{{product.image.mediumURL}}"
                             alt="{{product.image.altText}}" />
                      }
                    }
                    @if (getFeatureGroupsCount(product) === 1) {
                      @if (getSelectedFeature(product) &&
                        getSelectedFeatureMediaUrl(product)) {
                        <img
                          src="{{ getSelectedFeatureMediaUrl(product) }}"
                          alt=""/>
                      }
                    }
                  </div>
                  <div class="product-details">
                    <div class="product-title">
                      {{ product.name }}
                    </div>
                <price-display [price]="priceCalculationService
                                          .getProductPriceWithFeatures(product)"
                      [quantity]="product.quantity">
                    </price-display>
                    <input class="acc-checkbox" type="checkbox" id="acc-{{i}}" />
                    <label for="acc-{{i}}" class="acc-label">
                      {{ 'i18n.additionalProducts.showMore' | translate }}
                    </label>
                    <ul class="details">
                      @for (detail of product.bulletedDescription; track detail) {
                        <li
                          [innerHTML]="detail">
                        </li>
                      }
                    </ul>
                    @if (getFeatureGroupsCount(product) > 0) {
                      <div class="feature-selection"
                        >
                        @for (group of objToArray(product.featureGroups); track trackById($index, group)) {
                          <div class="feature-group"
                            >
                            <span class="group-name">
                              {{ group.name }}:
                            </span>
                            <single-option-chooser [displayStyle]="'DropDown'"
                              [options]="getFeaturesAsOptions(group)"
                              [selectedValue]="group.selectedFeature"
                                           (selectedValueChange)="selectedValueChanged(
                                               product.id, group.id, $event)">
                            </single-option-chooser>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="add-to-cart-container">
                  <mat-checkbox [checked]="additionalProductIsSelected(product.id)"
                    [labelPosition]="'before'"
                            (change)="setAdditionalProductIsSelected(
                                          product.id, $event.source.checked)">
                    <a mat-raised-button size="small" color="primary">
                      {{ 'i18n.additionalProducts.addToCart' | translate }}
                    </a>
                  </mat-checkbox>
                </div>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
</div>
<div class="total-price">
  <hr />
  <span class="label">{{ 'i18n.price.total' | translate }}: </span>
  <span class="price">
    {{ priceCalculationService.currentTotal.reducedAmount | priceFormat }}
  </span>
  @if (priceCalculationService.currentTotal.reduction > 0) {
    <div class="reduction-price"
      >
      {{ 'i18n.price.reduction' | translate }}
      {{ priceCalculationService.currentTotal.reduction | priceFormat }}
    </div>
  }
</div>
